import PhoneUtils from './phoneUtils';
import showNotification from 'commons/helpers/showNotification';
import StorageService from 'services/StorageService';
import {
  prepareCustomerName,
  prepareDateAndTime,
  prepareMessageForAllVariables,
  prepareProfessionalName,
} from './messageHelpers';
import { isAppTypeCourtRental } from 'commons/helpers/appTypeSettings';

function getWhatsAppUrl() {
  const isWhatsAppDesktop = StorageService.getIsWhatsAppDesktop();
  const whatsAppUrl = isWhatsAppDesktop ? 'whatsapp://send' : 'https://web.whatsapp.com/send';
  return whatsAppUrl;
}

const WhatsUtils = {
  sendMultiMessage({ phone, shouldNotCleanUpNumber, customerName, appointments, isPackage = false }) {
    if (!phone) {
      showNotification('warning', 'Nenhum telefone informado.');
      return;
    }
    const isCourtRental = isAppTypeCourtRental();
    const plural = appointments.length > 1;

    const body = appointments
      .map((app) => {
        const preparedDateTimeFormatted = prepareDateAndTime({ date: app.date, startTime: app.startTime });
        const preparedServiceName = app.serviceName;
        const preparedProfessionalName = prepareProfessionalName({
          isCourtRental,
          professionalName: app.user.name,
        });
        return `📅 ${preparedDateTimeFormatted}
📌 Serviço: ${preparedServiceName} - Profissional: ${preparedProfessionalName}`;
      })
      .join('\n');

    const preparedCustomerName = prepareCustomerName({
      isCourtRental,
      customerName,
    });
    const message = `Oi ${preparedCustomerName}, tudo bem?

${
  isPackage
    ? plural
      ? 'Este são os agendamentos do seu pacote'
      : 'Este é o agendamento do seu pacote'
    : plural
    ? 'Este é um lembrete para os seus agendamentos'
    : 'Este é um lembrete para o seu agendamento'
}.

${body}

Obrigado!`;

    const sanitizedPhone = shouldNotCleanUpNumber
      ? PhoneUtils.sanitizePhoneNumberRemovePlus(phone)
      : PhoneUtils.sanitizePhoneNumberWithCountryPrefix(phone);

    window.open(`${getWhatsAppUrl()}/?phone=${sanitizedPhone}&text=${encodeURIComponent(message)}`, '_blank');
  },

  sendMessage({
    phone,
    text,
    customerName,
    shouldNotCleanUpNumber,
    serviceName,
    date,
    startTime,
    endTime,
    totalServiceValue,
    professionalName,
  }) {
    if (!phone) {
      showNotification('warning', 'Nenhum telefone informado.');
      return;
    }
    const isCourtRental = isAppTypeCourtRental();

    const selectedMsgString = prepareMessageForAllVariables({
      message: text,
      customerName,
      serviceName,
      date,
      startTime,
      endTime,
      totalServiceValue,
      professionalName,
      isCourtRental,
    });

    const sanitizedPhone = shouldNotCleanUpNumber
      ? PhoneUtils.sanitizePhoneNumberRemovePlus(phone)
      : PhoneUtils.sanitizePhoneNumberWithCountryPrefix(phone);

    window.open(
      `${getWhatsAppUrl()}/?phone=${sanitizedPhone}&text=${encodeURIComponent(selectedMsgString)}`,
      '_blank',
    );
  },

  openWhatsApp(fullPhoneCleanedup) {
    window.open(`${getWhatsAppUrl()}/?phone=${fullPhoneCleanedup}`, '_blank');
  },
};
export default WhatsUtils;
